import React, { Component } from 'react';
import Table from 'rc-table';
import { Icon } from 'react-fa';
import StatusBadgeRow from './StatusBadgeRow';
import Dialog from 'rc-dialog';
import 'rc-table/assets/index.css';
import ActiveRow from './ActiveRow';

class TablaSolicitudesPendientes extends Component {
    constructor(props) {
        super(props);
        this.state = { data: this.props.solicitudes, deleteDialogVisible: false, currentRow: null, infoDialogVisible: false, errorCodigo: "", errorDescripcion: "" };
        this.getFechaFormateada = this.getFechaFormateada.bind(this);
    }

    closeDeleteDialog() {
        this.setState({ deleteDialogVisible: !this.state.deleteDialogVisible });
    }

    deleteSolicitud(idSolicitud) {
        this.setState({ deleteDialogVisible: false });
        this.props.deleteSolicitudPendiente(idSolicitud)
    }

    deleteRow() {
        const row = this.state.currentRow;
        this.setState({ deleteDialogVisible: !this.state.deleteDialogVisible });
        this.props.eliminarSolicitud(row.id);
    }

    deleteRowConfirmation(row) {
        this.setState({
            deleteDialogVisible: !this.state.deleteDialogVisible,
            currentRow: row
        });
    }

    showInformation(row) {
        if (row.Estado !== undefined && row.Estado.toUpperCase() === 'E') {
            if (row.Error !== '0000000000') {
                this.showInfoDialog(true);

                let errorLink = this.props.plasticos.erroresLink.find(x => x.codigo == row.Error);
                if (errorLink !== undefined) {
                    this.setState({ errorCodigo: errorLink.codigo, errorDescripcion: errorLink.Descripcion });
                }
            }
        }
    }

    showInfoDialog(showIt) {
        this.setState({ infoDialogVisible: showIt });
    }

    editRow(row) {
    }

    getFechaFormateada(fecha) {
        fecha = new Date(fecha);
        let fechaFormated = fecha.getDate() + "/"
            + (fecha.getMonth() + 1) + "/"
            + (fecha.getFullYear()) + " a las "
            + (fecha.getHours()) + ":"
            + (fecha.getMinutes().toString().length == 1 ? '0' + fecha.getMinutes().toString() : fecha.getMinutes().toString());

        return fechaFormated;
    }

    render() {
        const { getFechaFormateada } = this;
        const columns = [
            {
                title: 'ESTADO',
                dataIndex: 'Estado',
                key: 'Estado',
                render: (text, record) => {
                    return <ActiveRow newCard={false} estado={record.Estado} isChildRow={true} />;
                }
            },
            {
                title: 'N°',
                dataIndex: 'Id',
                key: 'Id',
            },
            {
                title: 'TIPO DE SOLICITUD',
                dataIndex: 'descripcion',
                key: 'descripcion',
            },
            {
                title: 'CUENTA',
                dataIndex: 'Cuenta',
                key: 'Cuenta',
            },
            {
                title: 'SUCURSAL',
                dataIndex: 'descripcion',
                key: 'Sucursal',
                render: (index, row) => {
                    const sucursal = row.Sucursal + " - " + row.SucDesc;
                    return <span>{sucursal}</span>
                },
            },
            {
                title: 'FECHA',
                dataIndex: 'Fecha',
                key: 'Fecha',
                render: (index, row) => {
                    const fechaFormateada = getFechaFormateada(row.Fecha) + " por " + row.Login;
                    return <span>{fechaFormateada}</span>
                },
            },
            {
                title: '',
                dataIndex: 'delete',
                key: 'delete',
                render: (index, row) => row.Estado.toUpperCase() === 'O' || row.Estado.toUpperCase() === 'T' ? null : <span><Icon name="trash" className="hand-pointer" size="lg" onClick={() => this.deleteRowConfirmation(row)} /> </span>,
            },
            {
                title: '',
                dataIndex: 'info',
                key: 'info',
                render: (index, row) => row.Estado.toUpperCase() === 'E' ? <span><Icon name="info" className="ti-info-alt hand-pointer" size="lg" onClick={() => this.showInformation(row)} /> </span> : null
            }
        ];

        // Todo sacar el === undefined cuando se vaya a pórtico.
        if (this.props.solicitudes === undefined)
            return null;

        if (this.props.data.functions !== undefined) {
            if (this.props.data.functions.Socioversuc !== undefined || this.props.data.functions.Socioverbanco) {
                let tipoConsulta = "";
                if (this.props.data.functions.Socioverbanco) {
                    tipoConsulta = "BANCO";
                } else if (this.props.data.functions.Socioversuc) {
                    tipoConsulta = "SUCURSAL";
                }

                let solicitudes = this.props.solicitudes;
                let solicitudesResult = [];
                for (var i = 0; i < solicitudes.length; i++) {
                    if (solicitudes[i].Estado.toUpperCase() != 'O') {
                        if (tipoConsulta == "BANCO" || (tipoConsulta == "SUCURSAL" && solicitudes[i].Sucursal == this.props.plasticos.sucursalUsuarioId)) {
                            let sucursal = this.props.plasticos.sucursalesDelivery.find(x => x.Codigo == solicitudes[i].Sucursal);
                            let sucursalDesc = sucursal !== undefined ? sucursal.Descripcion : '';

                            solicitudesResult.push({
                                Estado: solicitudes[i].Estado,
                                Id: solicitudes[i].Id,
                                descripcion: solicitudes[i].Descripcion,
                                Fecha: solicitudes[i].Fecha,
                                PersonaNombre: solicitudes[i].PersonaNombre,
                                PersonaApellido: solicitudes[i].PersonaApellido,
                                Error: solicitudes[i].Col5,
                                Login: solicitudes[i].Login,
                                Sucursal: solicitudes[i].Sucursal,
                                SucDesc: sucursalDesc,
                                Cuenta: solicitudes[i].NumeroCuenta
                            });
                        }
                    }
                }

                let textoNoExistenTarjetas = "No existen solicitudes pendientes.";
                if (solicitudesResult.length == 0 && solicitudes.length > 0) {
                    textoNoExistenTarjetas = "No existen solicitudes pendientes asociadas a la sucursal del usuario."
                }

                return (
                    <div className="TablaSolicitudesPendientes" style={{ marginLeft: '20px', marginRight: '20px' }}>
                        <h2 style={{ marginTop: '30px' }}>Solicitudes en curso</h2>
                        <Table
                            columns={columns}
                            data={solicitudesResult}
                            rowKey={record => record.key}
                            emptyText={textoNoExistenTarjetas}
                            className="table-style-seleccionar-cuenta"
                            onDoubleClick={(record, index) => this.onRowDoubleClick(record, index)}
                        />

                        <div>
                            <Dialog
                                visible={this.state.deleteDialogVisible}
                                onClose={this.closeDeleteDialog.bind(this)}
                                animation="slide-fade"
                                maskAnimation="fade"
                                style={{ width: 600 }}
                                title="Quitar notificación de solicitud"
                                footer={
                                    [
                                        <button
                                            type="button"
                                            className="btn btn-default"
                                            key="cancel"
                                            onClick={() => this.deleteSolicitud(this.state.currentRow.Id)}
                                        >
                                            Aceptar
				                </button>,
                                        <button
                                            type="button"
                                            className="btn btn-default"
                                            key="delete"
                                            onClick={() => this.closeDeleteDialog(this)}
                                        >
                                            Cancelar
				                </button>
                                    ]
                                }
                            >

                                ¿Está seguro que desea eliminar la notificación de solicitud pendiente?
			<br />
                                Esta notificación se eliminará de manera permanente.
			<br />

                            </Dialog>
                        </div>

                        <div>
                            <Dialog
                                visible={this.state.infoDialogVisible}
                                onClose={() => this.showInfoDialog(false)}
                                animation="slide-fade"
                                maskAnimation="fade"
                                style={{ width: 400 }}
                                title="Detalles del error"
                                footer={
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        key="Cerrar"
                                        onClick={() => this.showInfoDialog(false)}
                                    >
                                        Aceptar
			                </button>
                                }
                            >
                                <laber>{"Detalle: " + this.state.errorDescripcion + ' (' + this.state.errorCodigo + ')'}</laber>
                            </Dialog>
                        </div>

                    </div>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}

export default TablaSolicitudesPendientes;
